// extracted by mini-css-extract-plugin
export default {"errorMessageCard":"FormMessageContainer_errorMessageCard__AmE4j"};